export default "__VITE_ASSET__qJZoZQVJ__"